const Categories = () => {
  const data = [
    {
      cateImg: "./images/category/cat1.png",
      cateName: "Breakfast",
    },
    {
      cateImg: "./images/category/cat2.png",
      cateName: "Dinner",
    },
    {
      cateImg: "./images/category/cat3.png",
      cateName: "Snack",
    },
    {
      cateImg: "./images/category/cat4.png",
      cateName: "Fastfood",
    },
    {
      cateImg: "./images/category/cat5.png",
      cateName: "Babies",
    },
    {
      cateImg: "./images/category/cat6.png",
      cateName: "vegetables",
    },
    {
      cateImg: "./images/category/cat7.png",
      cateName: "Fasting",
    },
    {
      cateImg: "./images/category/cat8.png",
      cateName: "Pets",
    },
    {
      cateImg: "./images/category/cat9.png",
      cateName: "Fruits",
    },
    {
      cateImg: "./images/category/cat10.png",
      cateName: "Protein Foods",
    },
    {
      cateImg: "./images/category/cat11.png",
      cateName: "Dairy",
    },    
  ]
  
  return (
    <>
      <div className='category'>
        {data.map((value, index) => {
          return (
            <div className='box f_flex' key={index}>
              <img src={value.cateImg} alt='' />
              <span>{value.cateName}</span>
            </div>
          )
        })}
      </div>
    </>
  )
}

export default Categories
